<div class="footer">
    <div class="top-text body-2">
        <span>
            For questions regarding products, shipping, orders or the use of this website, please contact Customer
            Service at <a class="top-text__link" href="tel:+18008404733">800-840-4733</a> or email
            <a class="top-text__link" href="mailto:customerService@brainstormlogistics.com"
                >customerService&#64;brainstormlogistics.com</a
            >
        </span>
    </div>
    <div class="footer-layout" aria-label="Footer" aria-roledescription="footer" [attr.aria-hidden]="false">
        <div class="footer-grid box-container">
            <h2 class="footer-logo">
                <img
                    alt="Go Home"
                    width="128"
                    height="31"
                    role="presentation"
                    src="assets/images/logos/rymax-logo.svg"
                    (libAccessibleClick)="clickLogo.emit()"
                />
            </h2>

            <div class="footer-column">
                <h3 class="h1">Rymax Shopping Site</h3>
                <ul>
                    @for (link of shopsLinks; track $index) {
                        <li>
                            <h4 class="link">{{ link.title }}</h4>
                            @if (link.path) {
                                <lib-footer-nav-link [label]="link.linkLabel!" [path]="link.path" />
                            } @else {
                                <p class="body-1" [innerHTML]="link.content"></p>
                            }
                        </li>
                    }
                </ul>
            </div>

            <div class="footer-column">
                <h3 class="h1">Customer care</h3>
                <ul>
                    @for (link of customerCareLinks; track $index) {
                        <li>
                            <h4 class="link">{{ link.title }}</h4>
                            <lib-footer-nav-link
                                [ariaLabel]="link.ariaLabel"
                                [label]="link.linkLabel!"
                                [path]="link.path!"
                            />
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</div>
